import { render, staticRenderFns } from "./organization_settings.vue?vue&type=template&id=66d26cc0&scoped=true&"
import script from "./organization_settings.vue?vue&type=script&lang=js&"
export * from "./organization_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d26cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d26cc0')) {
      api.createRecord('66d26cc0', component.options)
    } else {
      api.reload('66d26cc0', component.options)
    }
    module.hot.accept("./organization_settings.vue?vue&type=template&id=66d26cc0&scoped=true&", function () {
      api.rerender('66d26cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/tabs/organization_settings.vue"
export default component.exports